import { axiosGet, axiosPost, axiosDelete, axiosPut } from "../options/header";

// Create a new category
const createCategory = async (name) => {
    try {
        const response = await axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + '/knowledge-management/categories', {
            name
        });
        return response;
    } catch (error) {
        console.error("Error creating category", error);
    }
};

// Get all categories
const getCategories = async () => {
    try {
        const response = await axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + '/knowledge-management/categories');
        return response;
    } catch (error) {
        console.error("Error retrieving categories", error);
    }
};

// Update a category
const updateCategory = async (id, name) => {
    try {
        const response = await axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + `/knowledge-management/categories/${id}`, {
            name
        });
        return response;
    } catch (error) {
        console.error("Error updating category", error);
    }
};

// Delete a category
const deleteCategory = async (id) => {
    try {
        const response = await axiosDelete(process.env.VUE_APP_API_ENDPOINT_STARTER + `/knowledge-management/categories/${id}`);
        return response;
    } catch (error) {
        console.error("Error deleting category", error);
    }
};

// Create a new knowledge entry
const createKnowledge = async (categoryId, title, tags, description, files) => {
    try {
        const formData = new FormData();
        formData.append('categoryId', categoryId);
        formData.append('title', title);
        formData.append('description', description);
        tags.forEach(tag => formData.append('tags', tag));
        files.forEach(file => formData.append('files', file));

        const response = await axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + '/knowledge-management/knowledge', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response;
    } catch (error) {
        console.error("Error creating knowledge entry", error);
    }
};

// Get all knowledge entries
const getKnowledge = async () => {
    try {
        const response = await axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + '/knowledge-management/knowledge');
        return response;
    } catch (error) {
        console.error("Error retrieving knowledge entries", error);
    }
};

// Update a knowledge entry
const updateKnowledge = async (id, categoryId, title, tags, description, removeFileIds, previous,  newFiles) => {
    try {
        console.log(previous)
        const formData = new FormData();
        formData.append('categoryId', categoryId);
        formData.append('title', title);
        formData.append('description', description);
        tags.forEach(tag => formData.append('tags[]', tag));
        removeFileIds.forEach(file => formData.append('removeFileIds[]', file.id));
        previous.forEach(file => formData.append('previousFileIds[]', file.id));
        newFiles.forEach(file => formData.append('files', file));

        const response = await axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + `/knowledge-management/knowledge/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response;
    } catch (error) {
        console.error("Error updating knowledge entry", error);
    }
};

// Delete a knowledge entry
const deleteKnowledge = async (id) => {
    try {
        const response = await axiosDelete(process.env.VUE_APP_API_ENDPOINT_STARTER + `/knowledge-management/knowledge/${id}`);
        return response;
    } catch (error) {
        console.error("Error deleting knowledge entry", error);
    }
};

// Search knowledge entries
const searchKnowledge = async (query) => {
    try {
        const response = await axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + `/knowledge-management/knowledge/search?query=${encodeURIComponent(query)}`);
        return response;
    } catch (error) {
        console.error("Error searching knowledge entries", error);
    }
};

export {
    createCategory,
    getCategories,
    updateCategory,
    deleteCategory,
    createKnowledge,
    getKnowledge,
    updateKnowledge,
    deleteKnowledge,
    searchKnowledge
};
